import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Reveal, staggerContainer, staggerItem } from "@/components/site/Reveal";

const TESTIMONIALS = [
  {
    quote: "He recuperado 12 horas a la semana. Mi asistente gestiona toda mi agenda y las llamadas de clientes.",
    name: "Marta P.",
    role: "Arquitecta autónoma",
    initials: "MP",
    color: "#EEEDFE",
    ink: "#3C3489",
  },
  {
    quote: "Viajo cada semana por trabajo y ya no toco un buscador de vuelos. Me llega el itinerario hecho al calendario.",
    name: "Javier R.",
    role: "CEO, consultora comercial",
    initials: "JR",
    color: "#E1F5EE",
    ink: "#085041",
  },
  {
    quote: "Empezamos con el plan Básico y fuimos añadiendo funciones. La flexibilidad es lo mejor con diferencia.",
    name: "Lucía G.",
    role: "Gerente, clínica dental",
    initials: "LG",
    color: "#FAECE7",
    ink: "#712B13",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-brand-bgAlt py-20 sm:py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal className="text-center text-[13px] uppercase tracking-[0.12em] text-brand-gray">
          Testimonios
        </Reveal>
        <Reveal className="mx-auto mt-3 max-w-2xl text-center text-3xl sm:text-4xl font-medium tracking-tight text-brand-ink">
          Lo que dicen nuestros clientes
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          className="mt-12 grid gap-5 md:grid-cols-3"
        >
          {TESTIMONIALS.map((t) => (
            <motion.figure
              key={t.name}
              variants={staggerItem}
              className="rounded-[14px] border border-brand-line bg-white p-7"
              data-testid={`testimonial-${t.initials.toLowerCase()}`}
            >
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={16} className="fill-[#EF9F27] text-[#EF9F27]" />
                ))}
              </div>
              <blockquote className="mt-4 text-[14.5px] leading-relaxed text-brand-ink">
                «{t.quote}»
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span
                  className="flex h-10 w-10 items-center justify-center rounded-full text-[14px] font-medium"
                  style={{ background: t.color, color: t.ink }}
                >
                  {t.initials}
                </span>
                <span>
                  <span className="block text-[14px] font-medium text-brand-ink">{t.name}</span>
                  <span className="block text-[12.5px] text-brand-gray">{t.role}</span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
